import React from 'react';
import { uniqueId } from '../../utils/helpers';
import PdpSubmissionItem from './pdpSubmissionItem';
import { withNurseryContext } from '../../contexts/NurseryContext';
const PdpSubmission = ({ title, data, nurserySlug }) => {
    const launchCarousel = (e) => {
        e.preventDefault();
    };
    const filteredItems = data.filter((item) => {
        if (nurserySlug
            && !item.is_photo
            && item.contributor_info.is_nursery) {
            return item.contributor_info.slug === nurserySlug;
        }
        return true;
    });
    const items = filteredItems.map((item, index) => (React.createElement(PdpSubmissionItem, { key: uniqueId(item.contributor_info.name), data: item, title: title, launchCarousel: launchCarousel, activeIndex: index })));
    return (items && items.length > 0) && (React.createElement("div", { className: "submissions_wrapper" },
        React.createElement("div", { className: "submissions" },
            React.createElement("h2", null, `Garden photo gallery of ${title}`),
            React.createElement("div", { className: "submissions_grid" }, items))));
};
export default withNurseryContext(PdpSubmission);
